import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {logger} from "@services/logger/logger.service";

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => logger.error(err));
